export default "/images/device-2.jpg?1d97b4da761bf2bd92154c8f4093fecd";